// NACUII real images from Google Drive folder "Fotos finales RENTA"
// Format: drive.google.com/thumbnail?id=XXX&sz=w1920 (high resolution hotlinkable)

const drive = (id) => `https://drive.google.com/thumbnail?id=${id}&sz=w1920`;
const CDN = "https://lirp.cdn-website.com/bf64e80e/dms3rep/multi/opt";

// Real photos from Drive (Fotos finales RENTA folder)
export const driveImages = {
  // Hero / Exterior
  houseNight: drive("1SCN0FTrpqbr-86PmC1vIi0DoaINQQTkt"),       // Casa nocturna iluminada con cactus (HERO)
  exteriorRender1: drive("1rj2_LfgpqDb_l-JfWHGQbLUDsfPyPh7P"),  // Render exterior con cactus alto
  exteriorRender2: drive("1NbAOX5xf10aQwjpQAKurESOWIpkeI_BR"),  // Render exterior frontal con palapa y muebles
  exteriorFlowers: drive("1JYrmjccWVDTeqAwvhpW7iWmK-RldklJl"),  // Casa con flores naranjas/jardín

  // Interior
  bedroomQueen: drive("1zszK9lGtTQTd7eO0z_mncFZ8-Mgsxjwt"),     // Recámara queen con cama king
  bathroomSingleVanity: drive("1lrsxn09NmGueXaWSWl6K670kQNDB90DH"), // Lavabo blanco con espejo redondo
  bathroomDoubleVanity: drive("14_cc9XjOvciXRvPnq7Swpf5cvE3RqRsS"), // Doble lavabo con dos espejos
  livingDining: drive("1-SktHFR-Is1xF86Ev_rZsu8cQvrHJ4WG"),     // Sala-comedor con cocina al fondo
  kitchenIsland: drive("1L8Q7sN6GYFuSkVHSvQjbpfp0aUDRM3wr"),    // Cocina con isla blanca y luces colgantes
  livingDining2: drive("1C4YvuentWQa0V4ekHc1HwEOIiKMjfDd-"),    // Sala-comedor con cocina (otra vista)
  bathroomTub: drive("1wp-F1AH-a8kYZqP5v0YqjtfPOBM7ngPJ"),      // Baño con tina y vista, espejo circular
  bedroomTwin: drive("1AIVG2CP1OMHXxH6mrqzCq2I1a-qRLVtb"),      // Recámara con 2 camas + ventilador
  bedroomGarden: drive("1IJX3PVTItsZVYJFxPWqbNgKlcYDyPcg2"),    // Recámara con vista al jardín y ventilador
  livingTV: drive("14aOk5dvYzDz4TSJZBeyfqxySp1EtSFg1"),         // Sala con TV y cortinas

  // Exterior amenities
  oceanTerrace: drive("1PSdQEfJ4DewZGbRCfdOup9ZwwHo5RLu4"),     // Terraza/sala exterior con vista al mar
  poolInfinity: drive("1Mj0TxKOd8JWuZBXVvZ-VI3PHwrWJcC7w"),     // Alberca infinita con tumbonas + palmeras
  villaPoolView: drive("1KWnjP-I3bKcXwnyPsptKOyoREu8_BNnX"),    // Vista villa con alberca y áreas verdes
  palapaDining: drive("1WhyaQFN-uP14DfhU4JL7UOxohoyFwi72"),     // Palapa con bar/mesa de comedor
  palapaWooden: drive("1WHT_40Y27EwCqvdaPRbqNLg6M3xOIuEu"),     // Palapa con techo de madera y muebles
  firepitArea: drive("1PkA6_eBbIViAJyjXDZxPNEM06MK0nTHK"),      // Exterior con sofás (área fire pit)
  poolFountain: drive("1ct9qQyBPDTYD6R2pCT1pY6QKVXMvnBan"),     // Tumbonas blancas alberca + fuente
  outdoorTerrace: drive("1jVi6pkahV_97JwXZUSR4zEJ0xNEu3Cgo"),   // Terraza exterior con tumbonas + sombrillas
  outdoorKitchen: drive("1hO4cRv6MSJZZ-_cxaUjLx9Zy24jevqmd"),   // Cocina exterior con horno de piedra
  bbqGrill: drive("17PJpTE56gUn8cb_U7jtzWZSfxKs9RVbB"),         // Asador BBQ con barra de bambú
  sunsetView: drive("1tqL6NfylL-aMt4662G801wlJkcmghNoE")        // Atardecer con montañas en el fondo
};

// Convenience aliases for backward compatibility with existing components
export const images = {
  // Hero & exterior real photos
  realHouseNight: driveImages.houseNight,
  realExteriorFlowers: driveImages.exteriorFlowers,
  realLivingRoom: driveImages.livingDining,
  realTwinBedroom: driveImages.bedroomTwin,
  realQueenYellow: driveImages.bedroomGarden,
  realVanitySingle: driveImages.bathroomSingleVanity,
  realMasterBedroom: driveImages.bedroomQueen,
  realBathroomTub: driveImages.bathroomTub,
  realDoubleVanity: driveImages.bathroomDoubleVanity,
  realExtra1: driveImages.kitchenIsland,
  realExtra2: driveImages.livingDining2,
  realExtra3: driveImages.livingTV,
  realExtra4: driveImages.outdoorKitchen,
  realExtra5: driveImages.bbqGrill,
  realExtra6: driveImages.sunsetView,
  realExtra7: driveImages.outdoorTerrace,
  realExtra8: driveImages.exteriorRender1,

  // Aerial/architectural (renders + drone shots from original site)
  heroAerial1: driveImages.exteriorRender2,
  heroAerial2: driveImages.exteriorRender1,
  heroAerial3: driveImages.villaPoolView,
  heroFacade: driveImages.houseNight,
  heroFachadaOriente: driveImages.houseNight,
  poolArea: driveImages.poolInfinity,
  rooftop: driveImages.oceanTerrace,
  bbq: driveImages.bbqGrill,
  firePitNew: driveImages.firepitArea,
  motorLobby: driveImages.exteriorRender2,
  render13: driveImages.villaPoolView,
  render15: driveImages.poolFountain,
  playaTodosSantos: `${CDN}/Playa.Todos.santos-1920w.jpg`
};
